module.exports = __webpack_public_path__ + "img/dypitch-0.a327dcc6.jpg";